export const BSC_RPC_URLS = [
  'https://bsc-dataseed1.bnbchain.org',
  'https://bsc-dataseed2.bnbchain.org',
  'https://bsc-dataseed1.bnbchain.org',
]

export const BSC_TESTNET_RPC_URLS = [
  'https://data-seed-prebsc-1-s1.bnbchain.org:8545',
  'https://bsc-testnet-rpc.publicnode.com',
  'https://data-seed-prebsc-2-s2.bnbchain.org:8545',
]

export const ETH_RPC_URLS = [
  'https://arb1.arbitrum.io/rpc',
  'https://arb1.arbitrum.io/rpc',
  'https://arb1.arbitrum.io/rpc',
]

export const BASE_RPC_URLS = [
  'https://mainnet.base.org',
  'https://mainnet.base.org',
  'https://mainnet.base.org',
]

export const BASE_SEPOLIA_RPC_URLS = [
  'https://sepolia.base.org',
  'https://sepolia.base.org',
  'https://sepolia.base.org',
]

export const POLYGON_RPC_URLS = [
  'https://polygon-rpc.com',
  'https://polygon-rpc.com',
  'https://polygon-rpc.com',
]
